<template>
  <Content @back="$router.go(-1)">
    <template v-slot:nav_left>
      <p>一级指标</p>
    </template>
    <template v-slot:nav_right>
      <template>
        <div class="yioks_btn" @click="handleOpenAddDialog(true)">
          添加一级指标
        </div>
      </template>
    </template>

    <template v-slot:content_right>
      <div class="base-content-warpper">
        <div class="content-inner-wrapper">
          <div class="select_wrap">
            <div class="select_box left">
              <!-- <el-select
                v-model="filterData.jixiaoType"
                class="y-input"
                clearable
                placeholder=""
                @change="changeQuery(true)"
              >
                <el-option label="全部指标类型" value=""></el-option>
                <el-option
                  v-for="item in performanceGroupTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select> -->
            </div>
            <div class="select_box right">
              <input
                v-model.trim="filterData.targetName"
                type="text"
                class="yioks_input"
                style="width: 160px"
                placeholder="请输入关键字"
                @keyup.enter="changeQuery(true)"
              />
              <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
            </div>
          </div>
          <div class="list_wrap" v-if="!loading && !empty">
            <div class="table">
              <div class="thead">
                <div class="tr">
                  <div class="th seq">序号</div>
                  <div class="th targetName">指标名称</div>
                  <div class="th targetTotalScore">分值</div>
                  <div class="th weight">权重</div>
                  <div class="th targetRemark">指标备注</div>
                  <div class="th targetSuggest">指标建议</div>
                  <div class="th action">操作</div>
                </div>
              </div>
              <div class="scrollArea">
                <vue-scroll>
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div
                        class="tr"
                        v-for="(item, index) in listData"
                        :key="index"
                      >
                        <div class="td seq">
                          <p>{{ index + 1 }}</p>
                        </div>
                        <div class="td targetName">
                          <p>{{ item.targetName }}</p>
                        </div>
                        <div class="td targetTotalScore">
                          <p>0 - {{ item.targetTotalScore }}</p>
                        </div>
                        <div class="td weight">
                          <p>{{ item.weight }}%</p>
                        </div>
                        <div class="td targetRemark">
                          <p>{{ item.targetRemark }}</p>
                        </div>
                        <div class="td targetSuggest">
                          <p>{{ item.targetSuggest }}</p>
                        </div>
                        <div class="td action">
                          <p>
                            <span class="item" @click="handleCheckDetails(item)"
                              >查看</span
                            >
                            <span class="split">/</span>
                            <span class="item" @click="handleEditRow(item)"
                              >编辑</span
                            >
                            <span class="split">/</span>
                            <span class="item" @click="handleDeleteRow(item)"
                              >删除</span
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>
          </div>
          <yioks-loading v-if="loading" />

          <yioks-empty
            v-if="empty"
            tips="暂时没有数据，"
            name="立即添加一级指标"
            @callback="handleOpenAddDialog(true)"
          ></yioks-empty>
        </div>

        <Pagination :total="total" :page.sync="page" />

        <template v-if="isOpenPerformanceDialog">
          <add-first-target-dialog
            :isShowDialog.sync="isOpenPerformanceDialog"
            :isEditMode="isInEditMode"
            :defaultFormData="editRow"
            :titleName="'一级'"
            @closeDialogCallBack="handleDialogCallBack"
          ></add-first-target-dialog>
        </template>
        <yioks-tips
          :showTip="deleteFlag"
          tipMsg="确认删除该指标吗？"
          :loading="repeatDelete"
          @callback="handleConfirmDelete"
        ></yioks-tips>
      </div>
    </template>
  </Content>
</template>

<script>
import { getTargetList, deleteTarget } from "@/api/performance";
import { performanceGroupTypeList } from "@/assets/js/yioksSelect";

export default {
  components: {
    Content: () => import("@/components/layout/list"),
    Pagination: () => import("@/components/Pagination"),
    // "performance-dialog": () => import("./components/PerformanceDialog"),
    "add-first-target-dialog": () => import("./components/addFirstTarget"),
    "yioks-tips": () => import("@/components/YioksTip"),
  },

  data() {
    return {
      performanceGroupTypeList,
      filterData: {
        targetName: "",
        targetUpUuid: "",
        jixiaoType: "",
      },
      loading: false,
      empty: false,
      total: 0,
      page: 0,
      pageSize: 20,

      isOpenPerformanceDialog: false,
      isInEditMode: false,
      editRow: {},
      deleteFlag: false,
      repeatDelete: false,
      deleteRow: {},
      targetLevel: 1,
      empty: false,
      listData: [],
    };
  },

  computed: {
    groupUuid() {
      const { groupUuid } = this.$route.params;
      return groupUuid;
    },
  },

  watch: {
    page(val) {
      this.changeQuery();
    }
  },

  created() {
    this.changeQuery(true);
  },

  methods: {
    changeQuery(flag) {
      this.$router.replace({
        path: this.$route.fullpath,
        query: {
          ...this.$route.query,
          ...this.filterData,
          page: this.page,
          size: this.pageSize,
        },
      });
      this.loadPageList();
    },

    // 加载页面指标列表
    loadPageList() {
      const { page, targetName } = this.$route.query;
      const paramsData = {
        groupUuid: this.groupUuid,
        size: this.pageSize,
        targetName,
        page,
      };
      this.loading = true;
      getTargetList(paramsData)
        .then((res) => {
          this.loading = false;
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          const { totalElements, empty, content } = res;
          this.empty = empty;
          this.total = totalElements;
          this.listData = content;
        })
        .catch((err) => {
          this.loading = false;
          console.error("err", err);
        });
    },

    handleCheckDetails(row) {
      const { groupUuid, uuid, targetTotalScore } = row;
      this.$router.push({
        path: `/secondIndicator/${groupUuid}/${uuid}`,
        query: {
          maxScore: targetTotalScore
        }
      });
    },

    handleEditRow(row) {
      this.editRow = row;
      this.isInEditMode = true;
      this.handleOpenAddDialog(true); // 打开弹窗
    },

    handleDeleteRow(row) {
      this.deleteRow = row;
      this.deleteFlag = true;
    },

    // 打开添加指标弹窗
    handleOpenAddDialog(flag) {
      this.isOpenPerformanceDialog = flag;
    },

    // 确认删除
    handleConfirmDelete(confirm) {
      if (confirm) {
        const { uuid } = this.deleteRow;
        deleteTarget(uuid)
          .then((res) => {
            if (res.code) {
              this.$message.error(res.msg);
              return;
            }
            this.deleteFlag = false;
            this.deleteRow = {};
            this.changeQuery(true)
          })
          .catch((err) => {
            console.error("err", err);
          });
      } else {
        this.deleteFlag = false;
        this.deleteRow = {};
      }
    },

    // 添加/编辑弹窗回掉
    handleDialogCallBack(dialogStatus, successFlag) {
      this.handleOpenAddDialog(dialogStatus);
      if (successFlag) {
        this.changeQuery(true);
      }
      this.editRow = {};
      this.isInEditMode = false;
    },
  },
};
</script>


<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.content-inner-wrapper
  height 560px
.list_wrap
  flex 1
  overflow hidden
  .table
    display flex
    flex-direction column
    flex 1
    width 100%
    // margin: 30px 0 0;
    .thead, .tbody
      border 1px solid $color_white
    .thead
      margin 0 40px
      .tr
        height 45px
        display flex
    .scrollArea
      height 425px
      padding-bottom 15px
      /* flex 1 */
      /* overflow hidden */
    .tbodyWrap
      display block
      // padding: 0 40px;
    .tbody
      display block
      width 810px
      margin-left auto
      margin-right auto
      max-width 810px
      border-top none
      border-bottom none
      .tr
        height 49px
        display flex
        border-bottom 1px solid $color_white
    .th, .td
      height 100%
      /* flex: 1 1 auto; */
      display flex
      justify-content center
      align-items center
      font-size $font_size_medium
      border-right 1px solid $color_white
    .th:last-child, .td:last-child
      border-right none
    .td
      p
        white-space nowrap
        overflow hidden
        text-overflow ellipsis
        color $color_white
.seq
  width 6%
.targetName
  width 24%
.targetTotalScore
  width 8%
.weight
  width 8%
.targetRemark
  width 19%
.targetSuggest
  width 19%
.action
  width 16%
  .item
    cursor pointer
    user-select none
    color $green_color
  .split
    margin 0 5px
</style>

<style lang="stylus" >
.y-input
  width 180px
  margin-right 20px
  input
    border-radius 0px !important
</style>
